import { initializeApp } from "firebase/app";
import {
  Auth,
  GoogleAuthProvider,
  User,
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut
} from "firebase/auth";

import { AppCfg } from "@/configs/app";

class FirebaseService {
  private _auth: Auth;
  constructor() {
    const app = initializeApp(AppCfg.firebase);
    const auth = getAuth(app);
    this._auth = auth;
  }

  get currentUser(): User | null {
    return this._auth.currentUser;
  }

  onAuthStateChanged(callback: (user: User | null) => void) {
    return onAuthStateChanged(this._auth, callback);
  }

  async signIn() {
    const provider = new GoogleAuthProvider();
    await signInWithPopup(this._auth, provider);
  }

  async signInWithEmail(email: string, password: string) {
    await signInWithEmailAndPassword(this._auth, email, password);
  }

  async registerWithEmail(email: string, password: string) {
    await createUserWithEmailAndPassword(this._auth, email, password);
  }

  async resetPassword(email: string) {
    await sendPasswordResetEmail(this._auth, email);
  }

  async signOut() {
    await signOut(this._auth);
  }
}

export const firebaseService = new FirebaseService();
